// ProcessComponent.js
import React, { Component } from 'react';
import { Input, Dropdown, Button, Grid, Feed } from 'semantic-ui-react';
import moment from 'moment';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import ImageAvater from '../../../../components/drive/Components/ImageAvater';
import ShowScenarioInputs from "../Drive/modals/ShowScenarioInputs";
import momentDateAndTime from '../../../../helpers/momentDateAndTime'

class ProcessComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProcessEventValue: '',
      selectedProcessTemplate: '',
      scenarioInputs: [],
      selectedProcessScenario: '',
      selectedProcessEvent: '',
      scenarioInputsModalFlag: false,
      selectedInitiativeActivityAction: {},
      selectedScenarioInputs: []
    };
  }

  manageScenarioInputModal = (modalFlag) => {
    this.setState({scenarioInputsModalFlag: modalFlag})
  }

  openModal = (action) => {
    this.setState({selectedInitiativeActivityAction: action});
    if(action && action.metaData && action.metaData.scenarioInputs){
      this.setState({selectedScenarioInputs: action.metaData.scenarioInputs});
    }
    this.manageScenarioInputModal(true); // Open modal
  }

  closeModal = () => {
    this.manageScenarioInputModal(false); // Close modal
  }

  render() {
    let role = this.props.selectedOrganisation && this.props.selectedOrganisation.role;
    const { initiativeActivityActions, user, processingType } = this.props;
    this.state.scenarioInputs = this.props.scenarioInputs;
    return (
      <div>
        <div tabTitle={<div>{processingType}</div>}></div>
        <div className="acc-header">{processingType}
        </div>
        {initiativeActivityActions && initiativeActivityActions.length > 0 ? (
          initiativeActivityActions.map((action, i) => (
            action.processingType == this.props.processingType ?
            <Feed key={i} className="bg-white pad_5" style={{ padding: 0, margin: "10px 0 0 0", background: "none" }}>
              <Feed.Event>
                <ImageAvater user={action.createdBy} className="clr-white w_24 h_24" imageStyle="clr-white w_24 h_24" />
                <Feed.Content>
                  <Feed.Summary>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ flex: 1 }}>
                        {action.createdBy.firstName} {action.createdBy.lastName} <br />
                        {action.name} <br />
                        {action.templateDetails && action.templateDetails.name ? action.templateDetails.name : ""}
                        {action.metaData && action.metaData.scenarioName ? action.metaData.scenarioName : ""}
                      </div>
                      <span style={{ marginLeft: '10px', textAlign: 'right' }}>
                        {momentDateAndTime(action.createdAt)}
                        <br />
                        {(action.createdBy._id.toString() === user._id.toString() || role === "workspaceOwner") ? (
                          <span>
                            {action.metaData.scenarioId ? <span style={{}} className="clr-blue text-underline cursor-pointer" onClick={() => this.openModal(action)}>
                              View
                            </span> : ""}
                          </span>
                        ) : ''}
                      </span>
                    </div>
                  </Feed.Summary>
                </Feed.Content>
              </Feed.Event>
            </Feed>:""
          ))
        ) : ""}
        <ShowScenarioInputs
          open={ this.state.scenarioInputsModalFlag }
          close={ this.closeModal }
          selectedInitiativeActivityAction = { this.state.selectedInitiativeActivityAction }
          selectedScenarioInputs = { this.state.selectedScenarioInputs }
        />
      </div>
    );
  }
}

export default ProcessComponent;